import { useTranslation } from "react-i18next";
import { Navigate, useLocation } from "react-router";
import { useAuth } from "../auth/AuthProvider";
import { Spinner } from "./ui";

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { t } = useTranslation("common");
  const { status } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return (
      <div className="flex min-h-dvh items-center justify-center">
        <Spinner className="size-6 text-fg-subtle" />
        <span className="sr-only">{t("session.checking")}</span>
      </div>
    );
  }

  if (status === "anonymous") {
    return <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}${location.hash}` }} />;
  }

  return <>{children}</>;
}
